import { useState } from 'react';
import BillManagementContext from './BillManagementContext';

const BillManagementState = (props) => {
  const [formvalue, setformvalue] = useState([]); //API -->
  const [billListValue, setBillListValue] = useState([]); //API -->
  const [paymentListValue, setPaymentListValue] = useState([]); //API -->
  const [formData, setFormData] = useState({ name: '', phone: '', address: '' });
  const today = new Date().toISOString().split('T')[0];
  const [isMinusAmount, setIsMinusAmount] = useState(false);
  const [allPrice, setAllPrice] = useState({
    dueAmount: 0,
    totalAmount: 0,
    paybleAmount: 0,
    paidAmount: 0
  });
  const [venderBillFormData, setVenderBillFormData] = useState({
    vendorId: null,
    billDate: today,
    totalAmount: null,
    paidAmount: null,
    paymentMode: '',
    referenceNo: '',
    notes: ''
  });
  const [paymentBillFormData, setPaymentBillFormData] = useState({
    vendorId: null,
    vendorBillId: null,
    paymentDate: today,
    amount: null,
    paymentMode: null,
    referenceNo: null,
    notes: ''
  });
  const [billForm, setBillForm] = useState({
    vendorId: '',
    billNo: '',
    billDate: today,
    totalAmount: '',
    paidAmount: '',
    paymentMode: '',
    billImage: '',
    notes: '',
    referenceNo: ''
  });

  const [vendorId, setVendorId] = useState('');
  const [date, setDate] = useState(null);

  const [modal, setModal] = useState(false); //ADD DATA MODEL -->
  const [billModal, setBillModal] = useState(false); //ADD DATA MODEL -->
  const [paymetnModal, setPaymetnModal] = useState(false); //ADD DATA MODEL -->
  const [paymentListModal, setPaymentListModal] = useState(false); //List DATA MODEL -->
  const [addbel, setAddBel] = useState(false); //ADD ORG BEL -->
  const [pageNumber, setpageNumber] = useState(1); //PAGINATION -->
  const [recordsPerPage, setRecordsPerPage] = useState(10); //PAGINATION -->
  const [sortOrder, setSortOrder] = useState('DESC'); //SORTING -->
  const [sortBy, setSortBy] = useState('createdAt'); //SORTING -->
  const [filter, setFilter] = useState({
    phone: '',
    name: '',
    createdAt: ''
  }); //SEARCHING FILTER -->
  const [isHovering, setIsHovering] = useState(false); //HOVWER SORTING -->
  const [isSwitchOn, setIsSwitchOn] = useState(false); //TOGGLE SWITCH -->
  const [url, setUrl] = useState('');
  const [editIndex, seteditIndex] = useState(-1); //EDIT -->
  const [totalRecord, setTotalRecord] = useState(); //TOTAL RECORD -->
  const [isAddHandle, setIsAddHandle] = useState(true); //PASS HIDE OR UNHIDE -->
  const [progress, setProgress] = useState(0);
  const [togglesubmit, setToggle] = useState(false);
  const [filterOrderId, setFilterOrderId] = useState('');

  return (
    <>
      <BillManagementContext.Provider
        value={{
          formvalue,
          setformvalue,
          modal,
          setModal,
          addbel,
          setAddBel,
          pageNumber,
          setpageNumber,
          recordsPerPage,
          setRecordsPerPage,
          sortOrder,
          setSortOrder,
          sortBy,
          setSortBy,
          filter,
          setFilter,
          isHovering,
          setIsHovering,
          isSwitchOn,
          setIsSwitchOn,
          url,
          setUrl,
          editIndex,
          seteditIndex,
          totalRecord,
          setTotalRecord,
          isAddHandle,
          setIsAddHandle,
          progress,
          setProgress,
          togglesubmit,
          setToggle,
          vendorId,
          setVendorId,
          filterOrderId,
          setFilterOrderId,
          formData,
          setFormData,
          billModal,
          setBillModal,
          billForm,
          setBillForm,
          billListValue,
          setBillListValue,
          venderBillFormData,
          setVenderBillFormData,
          paymentListModal,
          setPaymentListModal,
          paymentListValue,
          setPaymentListValue,
          paymetnModal,
          setPaymetnModal,
          paymentBillFormData,
          setPaymentBillFormData,
          allPrice,
          setAllPrice,
          isMinusAmount,
          setIsMinusAmount
        }}
      >
        {props.children}
      </BillManagementContext.Provider>
    </>
  );
};

export default BillManagementState;
